module.exports = __webpack_public_path__ + "img/microplastics-8.39c2d7bc.png";